import { ActividadFilterComponent } from '../actividad-filter';
import {Component, OnInit, ViewChild, OnDestroy, AfterViewInit} from '@angular/core';
import { NavigationService } from '../../../services/navigation-service';
import {
  ActividadService, ACTIVITY_SCREEN_ALL, ACTIVITY_SCREEN_MY_NETWORK,
} from '../../../services/actividad-service';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import {PATH_ACTIVIDAD, PATH_AGENDA} from '../../../navigation/navigation.module';
import { AgendaComponent } from '../../agenda/agenda/agenda.component';
import { PermisosService, PERM_ACCIONES_ID } from '../../../services/permisos-service';
import { SpinnerService } from '../../../services/spinner-service';
import {FirebaseMessagingService} from '@services/firebase-messaging.service';

@Component({
selector: 'app-actividad',
templateUrl: './actividad.component.html',
  styleUrls: ['./actividad.component.scss']
})
export class ActividadComponent implements OnInit, AfterViewInit, OnDestroy {

  actividadPropia = [];
  actividadMiRed = [];
  actividadTodos = [];

  actividadPropiaPage: number = 0;
  actividadMiRedPage: number = 0;
  actividadTodosPage: number = 0;

  selectedTabIndex: number = 0;

  actividadMiRedOpened = false;
  actividadTodosOpened = false;

  private selectedMotoresArray = [];
  private selectedColaboradoresArray = [];
  private selectedCuentasArray = [];
  private selectedContactosArray = [];
  private filterEvent: any = {};

  ACTIVITY_SCREEN_ALL = ACTIVITY_SCREEN_ALL;
  ACTIVITY_SCREEN_MY_NETWORK = ACTIVITY_SCREEN_MY_NETWORK;

  actividadReturned = {};
  filtersOpen = {};
  updateLastAccessFlag = {};

  showPropiaBubble: boolean = false;
  showAllBubble: boolean = false;
  showMiRedBubble: boolean = false;
  private bubbleSubscriber;

  tabActividadTodosAllowed = true;

  private currentTabs = ['agenda', /*'mi-red',*/ 'todos'];

  @ViewChild(AgendaComponent) agendaComponent;

  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  constructor(private navigationService: NavigationService,
              private actividadService: ActividadService,
              private route: ActivatedRoute,
              private location: Location,
              private permisosService: PermisosService,
              private spinnerSerice: SpinnerService,
              private firebaseService: FirebaseMessagingService,
  ) {
    this.permisosService.verificarAccesoDeURL();
    this.tabActividadTodosAllowed = this.permisoAutorizado(PERM_ACCIONES_ID.P_Actividad_Todos);
    this.currentTabs = this.permisosService.tabsPermitidas(this.currentTabs, [PERM_ACCIONES_ID.P_Actividad_Todos], ['todos']);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const page = this.route.snapshot.params['page'];

      if (this.currentTabs.indexOf(page) === -1 ||
          (page === 'todos' && !this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_Actividad_Todos))) {
        this.selectedTabIndex = 0;
      } else {
        this.selectedTabIndex = this.currentTabs.indexOf(page);
      }

      switch (page) {
        case 'agenda':
          this.sendAnalyticsData('agenda');
          break;
        case 'mi-red':
          this.sendAnalyticsData('mi-red');
          this.actividadMiRedOpened = true;
          this.getActividad(ACTIVITY_SCREEN_MY_NETWORK);
          break;
        case 'todos':
          this.sendAnalyticsData('todos');
          this.actividadTodosOpened = true;
          this.getActividad(ACTIVITY_SCREEN_ALL);
          break;
        default:
          this.location.go(PATH_AGENDA + '/' + this.currentTabs[0]);
          this.sendAnalyticsData(this.currentTabs[0]);
          break;
      }
    });
  }

  ngAfterViewInit() {

    this.showAllBubble = this.actividadService.getActivityFlag(ACTIVITY_SCREEN_ALL);
    // this.showMiRedBubble = this.actividadService.getActivityFlag(ACTIVITY_SCREEN_MY_NETWORK);

    this.bubbleSubscriber = this.actividadService.checkFlag$.subscribe(flag => {
      this.showAllBubble = this.actividadService.getActivityFlag(ACTIVITY_SCREEN_ALL);
      // this.showMiRedBubble = this.actividadService.getActivityFlag(ACTIVITY_SCREEN_MY_NETWORK);
    });
  }

  ngOnDestroy() {
    if (this.bubbleSubscriber) {
      this.bubbleSubscriber.unsubscribe();
    }
  }

  toggleNav(){
    this.navigationService.toggleNav(true);
  }

  onActividadMiRedFiltersApplied($event){
    this.actividadMiRedPage = 0;
    this.actividadService.actividadMiRedLastAppliedFilters = $event;
    this.onFiltersApplied(ACTIVITY_SCREEN_MY_NETWORK, $event);
  }

  onActividadTodosFiltersApplied($event){
    this.actividadTodosPage = 0;
    this.actividadService.actividadTodosLastAppliedFilters = $event;
    this.onFiltersApplied(ACTIVITY_SCREEN_ALL, $event);
  }

  onFiltersApplied(screen: string, event){

    this.selectedCuentasArray = event.cuentas.map(item => item.Id);
    this.selectedContactosArray = event.contactos.map(item => item.ClientContactId);
    this.selectedMotoresArray = []; //event.motores.map(item => item.Id);
    this.selectedColaboradoresArray = event.colaboradores.map(item => item.UserId);

    this.filterEvent = event;

    this.getActividad(screen);
  }

  getActividad(screen: string) {
    let page = screen === ACTIVITY_SCREEN_MY_NETWORK ? this.actividadMiRedPage : this.actividadTodosPage;

    this.actividadReturned[screen] = false;

    if (Object.keys(this.filterEvent).length) {
      this.filterEvent.endDate = moment(this.filterEvent.endDate).endOf('day').toDate();
    }

    // update last access ONLY if the filters are indeed fetching the last activities
    const updateLastAccess = Object.keys(this.filterEvent).length === 0 || moment(this.filterEvent.endDate).isSameOrAfter(moment().endOf('day'));
    this.spinnerSerice.setSoftSpinnerShowFlag(true);
    this.actividadService.getActividad(
      screen,
      Object.keys(this.filterEvent).length ? this.filterEvent.showConsignas : true,
      Object.keys(this.filterEvent).length ? this.filterEvent.showCuentas : true,
      Object.keys(this.filterEvent).length ? this.filterEvent.showPerfil : true,
      Object.keys(this.filterEvent).length ? this.filterEvent.showNegocios : true,
      Object.keys(this.filterEvent).length ? this.selectedCuentasArray : [],
      Object.keys(this.filterEvent).length ? this.selectedContactosArray : [],
      Object.keys(this.filterEvent).length ? this.selectedColaboradoresArray : [],
      Object.keys(this.filterEvent).length ? this.selectedMotoresArray : [],
      Object.keys(this.filterEvent).length ? this.filterEvent.startDate : moment().subtract(1,'week').toDate(),
      Object.keys(this.filterEvent).length ? this.filterEvent.endDate : moment().endOf('day').toDate(),
      page
    ).subscribe(data => {
      console.log(data);

      switch(screen){
        case ACTIVITY_SCREEN_MY_NETWORK:
          if (this.actividadMiRedPage){
            this.actividadMiRed = [...this.actividadMiRed, ...data];
          } else {
            this.actividadMiRed = data;
            if (this.currentTabs[this.selectedTabIndex] === 'mi-red' && updateLastAccess) {
              this.actividadService.updateNetworkLastAccess().subscribe();
              this.actividadService.setActivityFlag(ACTIVITY_SCREEN_MY_NETWORK, false);
              this.updateLastAccessFlag[ACTIVITY_SCREEN_MY_NETWORK] = false;
            } else {
              this.updateLastAccessFlag[ACTIVITY_SCREEN_MY_NETWORK] = true;
            }
          }
          break;
        case ACTIVITY_SCREEN_ALL:
          if (this.actividadTodosPage){
            this.actividadTodos = [...this.actividadTodos, ...data];
          } else {
            this.actividadTodos = data;
            if (this.currentTabs[this.selectedTabIndex] === 'todos' && updateLastAccess) {
              this.actividadService.updateEveryoneLastAccess().subscribe();
              this.actividadService.setActivityFlag(ACTIVITY_SCREEN_ALL, false);
              this.updateLastAccessFlag[ACTIVITY_SCREEN_ALL] = false;
            } else {
              this.updateLastAccessFlag[ACTIVITY_SCREEN_ALL] = true;
            }
          }
          break;
      }

      this.actividadReturned[screen] = true;
      this.spinnerSerice.setSoftSpinnerShowFlag(false);
    }, err => this.spinnerSerice.setSoftSpinnerShowFlag(false));
  }

  onBottomReached(reached: boolean) {
    switch (this.currentTabs[this.selectedTabIndex]) {
      case 'mi-red':
        this.actividadMiRedPage++;
        this.getActividad(ACTIVITY_SCREEN_MY_NETWORK);
        break;
      case 'todos':
        this.actividadTodosPage++;
        this.getActividad(ACTIVITY_SCREEN_ALL);
        break;
    }
  }

  onTabSwitch(event) {
    this.location.go(PATH_AGENDA + '/' + this.currentTabs[event.index]);
    const currentTab = this.currentTabs[event.index];

    switch (currentTab) {
      case 'mi-red':
        if (this.showMiRedBubble || !this.actividadMiRedOpened) {
          this.actividadMiRedOpened = true;
          this.actividadMiRedPage = 0;
          this.getActividad(ACTIVITY_SCREEN_MY_NETWORK);
        } else if (this.updateLastAccessFlag[ACTIVITY_SCREEN_MY_NETWORK]) {
          this.actividadService.updateNetworkLastAccess().subscribe();
          this.updateLastAccessFlag[ACTIVITY_SCREEN_MY_NETWORK] = false;
          this.actividadService.setActivityFlag(ACTIVITY_SCREEN_MY_NETWORK, false);
        }
        break;
      case 'todos':
        if (this.showAllBubble || !this.actividadTodosOpened) {
          this.actividadTodosOpened = true;
          this.actividadTodosPage = 0;
          this.getActividad(ACTIVITY_SCREEN_ALL);
        } else if (this.updateLastAccessFlag[ACTIVITY_SCREEN_ALL]) {
          this.actividadService.updateEveryoneLastAccess().subscribe();
          this.updateLastAccessFlag[ACTIVITY_SCREEN_ALL] = false;
          this.actividadService.setActivityFlag(ACTIVITY_SCREEN_ALL, false);
        }
        break;
    }
    this.sendAnalyticsData(this.currentTabs[event.index]);
  }

  toggleFilters(e, screen) {
    this.filtersOpen[screen] = e;
  }

  openFilters(screen) {
    this.filtersOpen[screen] = true;
  }

  sendAnalyticsData(url) {
    this.firebaseService.sendToAnalytics(PATH_ACTIVIDAD + '/' + url);
  }

  navigateToBuscadorAgenda() {
    this.agendaComponent.navigateToBuscador();
  }

  showNewConsignaDialog() {
    this.agendaComponent.showNewConsignaDialog();
  }

  permisoAutorizado(id) {
    return this.permisosService.permisoAutorizado(id);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/actividad/actividad/actividad.component.ts